import { StandardQuizQuestion } from '@/types/quizTypes';

export const UNITY_SCRIPTING_QUIZ: StandardQuizQuestion[] = [
  {
    id: "unity-script-1",
    question: "What is the correct order of Unity lifecycle methods?",
    options: [
      "Update, Start, Awake",
      "Awake, Start, Update",
      "Start, Awake, FixedUpdate",
      "OnEnable, Update, Start"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Unity lifecycle: Awake (first, initialize), OnEnable (when enabled), Start (before first Update), then Update/FixedUpdate every frame. OnDisable and OnDestroy occur when object is disabled/destroyed.",
    category: "lifecycle",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "unity-script-2",
    question: "When should you use FixedUpdate instead of Update?",
    options: [
      "For rendering",
      "For physics calculations and Rigidbody movement",
      "For UI updates",
      "For audio playback"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "FixedUpdate runs at a fixed timestep (default 0.02s) synchronized with the physics engine. Use it for physics operations. Update runs every frame for general logic.",
    category: "lifecycle",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "unity-script-3",
    question: "How do you find a GameObject by name in Unity?",
    options: [
      "GameObject.Find(\"Name\")",
      "FindObject(\"Name\")",
      "GetGameObject(\"Name\")",
      "Search(\"Name\")"
    ],
    correctAnswer: 0,
    correctAnswerIndex: 0,
    difficulty: "easy",
    explanation: "GameObject.Find(\"Name\") searches for an active GameObject by name. Note: This is slow, prefer caching references or using tags for frequent access.",
    category: "gameobject-access",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "unity-script-4",
    question: "What is the difference between GetComponent and GetComponentInChildren?",
    options: [
      "No difference",
      "GetComponent searches only current GameObject, GetComponentInChildren searches children too",
      "GetComponent is faster",
      "GetComponentInChildren is deprecated"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "GetComponent<T>() searches only the current GameObject. GetComponentInChildren<T>() searches the GameObject and all its descendants. GetComponentInParent searches upward.",
    category: "components",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "unity-script-5",
    question: "How do you instantiate a prefab at runtime?",
    options: [
      "new GameObject(prefab)",
      "Instantiate(prefab)",
      "Create(prefab)",
      "Spawn(prefab)"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Instantiate(prefab) creates a clone of a prefab or GameObject at runtime. You can also specify position, rotation, and parent transform.",
    category: "instantiation",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "unity-script-6",
    question: "What does Destroy(gameObject, 2.0f) do?",
    options: [
      "Destroys immediately",
      "Destroys the GameObject after 2 seconds",
      "Destroys 2 GameObjects",
      "Causes a compilation error"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Destroy(object, delay) destroys an object after the specified delay in seconds. Without delay, it destroys at the end of the current frame.",
    category: "object-lifetime",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "unity-script-7",
    question: "What is a Coroutine in Unity?",
    options: [
      "A physics calculation",
      "A method that can pause execution and resume over multiple frames",
      "A type of GameObject",
      "An animation clip"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Coroutines are methods that can yield (pause) and resume execution over time using IEnumerator and yield return. Useful for animations, delays, and asynchronous operations.",
    category: "coroutines",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "unity-script-8",
    question: "How do you detect when two objects collide?",
    options: [
      "Use Update method",
      "Implement OnCollisionEnter method",
      "Use FixedUpdate",
      "Call CheckCollision()"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "OnCollisionEnter/Stay/Exit detect physical collisions. OnTriggerEnter/Stay/Exit detect trigger overlaps. Both require Colliders; collision events need at least one Rigidbody.",
    category: "collision-detection",
    points: 15,
    type: "multiple-choice"
  }
];

export const generateUnityScriptingQuiz = () => ({
  questions: UNITY_SCRIPTING_QUIZ,
  passThreshold: 80,
  timeLimit: 900,
  category: 'unity-scripting'
});
